export default "__VITE_PUBLIC_ASSET__56fa1a0f__"